var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download-button"},[_c('b-button',{attrs:{"variant":"link"},on:{"click":_vm.addToPackShotDownloadList}},[_vm._v(_vm._s(_vm.$T('buttontext')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }